/** 
 Copyright Highway9 Networks Inc. 
 */ 
export const Types = {
  all: "all",
  // edge
  edge: "edge",
  cgwEdge: "cgwEdge",
  edgePool: "edgePool",
  operator: "mnoOperator",
  operatorRadio : "mnoOperatorRadio",
  // radio
  radio: "radio",
  radioGroup: "radioGroup",
  site: "radioSite",
  metricsTemplate: "metricsTemplate",
  walkTest : "walkTest",
  
  // subscriber
  deviceGroup: "deviceGroup",
  device: "device",
  endUserDevice: "eud",

  dnn: "dnn",

  // Profiles
  controller: "controller",
  monitoringSystem: "monitoringSystem",
  aaaServerProfile: "aaaServerProfile",
  clockPool: "clockPool",
  clock: "clock",
  mobilityProfile: "mobilityProfile",
  alertProfile: "alertProfile",
  // zone
  virtualMobilityZone: "zone",
  application: "application",
  qosProfile: "qosProfile",
  zoneGroup : "zoneGroup",
  
  // simulation
  simulatorAppliance: "simulator",
  radioSimulator: "radio",
  ueSimulator: "diagnosticsUe",
  
  // admin
  network: "network", // ns
  settings: "systemSettings",
  accessConfig: "accessConfig",
  caCert: "certificate",
  supportChannel: "supportChannel",
  radioGlobalConfig: "radioGlobalConfig",
  user : "user",
  apiToken : 'apiToken',
  defaultRadioManager: "defaultRadioManager",

  // others
  alarm: "alarm", // /alarm/query
  operation: "operation", // /operation/query
  log: "log", // auditLogs/query

  hardware: "vmcHardware",
  vmzGroup: "zoneGroup",
} as const;

export const UngroupedRadioID = "radioGroup-ungrouped";
